import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { loadStatus } from './aiChatSlice'

/**
 * Load `GET /api/ai/status/` for the current tenant, again after a tenant
 * switch (which resets the aiChat slice): the assistant's entry points read
 * from it whether they show (plan, budget, free setup help).
 */
export function useLoadAssistantStatus() {
  const dispatch = useDispatch()
  const currentTenantId = useSelector((s) => s.auth.currentTenantId)
  useEffect(() => {
    if (currentTenantId) dispatch(loadStatus())
  }, [currentTenantId, dispatch])
}
